import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("管理")
const _hoisted_2 = {
  id: "mycharts",
  ref: "myRef",
  class: "chart-box",
  style: {"width":"100%","height":"650px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 新增热门词 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "热门搜索 " }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.setHot
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, null, 512)
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
      title: "编辑热门词",
      onOk: _ctx.handleOk
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.word, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_space, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label:  '热门词' + (index+1) 
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: item.name,
                        "onUpdate:value": ($event: any) => ((item.name) = $event),
                        placeholder: "请输入关键词",
                        style: {"width":"170%"}
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_button, {
                        type: "link",
                        danger: "",
                        style: {"margin-left":"175%","margin-top":"-30px","position":"absolute"},
                        onClick: ($event: any) => (_ctx.onDel(index))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "dashed",
          block: "",
          onClick: _ctx.addHot
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ]))
}